import React from 'react'
import styled from 'styled-components/macro'
import { PiTag } from 'react-icons/pi'

interface TagCountBadgeProps {
  count: number
  className?: string
  onClick?: () => void
}

/**
 * TagCountBadge - A simple badge component that displays a tag icon with a count
 *
 * @example
 * <TagCountBadge count={18} />
 * <TagCountBadge count={5} onClick={() => console.log('clicked')} />
 */
export const TagCountBadge: React.FC<TagCountBadgeProps> = ({
  count,
  className,
  onClick,
}) => {
  return (
    <BadgeContainer
      className={className}
      onClick={onClick}
      $clickable={!!onClick}
    >
      <PiTag size={14} />
      <span>
        {count} {count === 1 ? 'tag' : 'tags'}
      </span>
    </BadgeContainer>
  )
}

const BadgeContainer = styled.div<{ $clickable: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  user-select: none;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e5e7eb;
      border-color: #d1d5db;
    }

    &:active {
      background-color: #d1d5db;
    }
  `}

  svg {
    flex-shrink: 0;
  }
`
